// Per-factor caps must match backend compute_credibility_score
const FACTOR_CAPS = {
  employment: 300,
  education: 150,
  conduct: 250,
  recommendations: 100,
  skills: 100,
  internships: 50,
  volunteer: 50,
  training: 50,
  achievements: 50,
};

const ORDER = ["employment", "education", "conduct", "recommendations", "skills", "internships", "volunteer", "training", "achievements"];

const LABELS = {
  employment: "Employment",
  education: "Education",
  conduct: "Conduct",
  recommendations: "Recommendations",
  skills: "Skills",
  internships: "Internships",
  volunteer: "Volunteer",
  training: "Training",
  achievements: "Achievements",
};

export default function ScoreBreakdown({ factors }) {
  if (!factors) return null;
  return (
    <div className="space-y-3" data-testid="score-breakdown">
      {ORDER.map((key) => {
        const value = factors[key] ?? 0;
        const max = FACTOR_CAPS[key] || 100;
        const pct = Math.min((value / max) * 100, 100);
        return (
          <div key={key} data-testid={`factor-${key}`}>
            <div className="flex justify-between text-sm">
              <span className="font-medium">{LABELS[key]}</span>
              <span className="font-mono-plex font-bold">
                <span className="text-ec-emerald">+{value}</span>
                <span className="text-ec-ink-soft">/{max}</span>
              </span>
            </div>
            <div className="h-1.5 bg-ec-mute mt-1 overflow-hidden">
              <div
                className="h-full bg-ec-ink transition-all duration-700"
                style={{ width: `${pct}%` }}
              />
            </div>
          </div>
        );
      })}
    </div>
  );
}
